import { render, staticRenderFns } from "./SchoolWorksDetail.vue?vue&type=template&id=dfc77a7c"
import script from "./SchoolWorksDetail.vue?vue&type=script&lang=js"
export * from "./SchoolWorksDetail.vue?vue&type=script&lang=js"
import style0 from "./SchoolWorksDetail.vue?vue&type=style&index=0&id=dfc77a7c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports